module.exports = __webpack_public_path__ + "94cfb6647dbe4413de1a3ae3682ba4eb.jpg";